// extracted by css-extract-rspack-plugin
export default {"EmptyState":"CijIlHXKFgAs7Bs5"};